import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkConditionsDisplayListComponent } from './network-conditions-display-list.component';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertModule } from '@fleet/ui/alert/alert.module';
import { DataItemComponent } from '@fleet/ui/data-item/data-item.component';

@NgModule({
  declarations: [NetworkConditionsDisplayListComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    DataItemComponent,
    AlertModule,
  ],
  exports: [NetworkConditionsDisplayListComponent],
})
export class NetworkConditionsDisplayListModule {}
